module.exports = __webpack_public_path__ + "img/close-icon.1ba6eca7.svg";